module.exports = __webpack_public_path__ + "img/our_team.06b97c1c.svg";